import './style.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import * as actions from './actions';

function formatContactNumber(str) {
  if (!str) return '';
  return str.slice(0, 3) + '-' + str.slice(3, 6) + '-' + str.slice(6);
}

class OrderTracking extends React.Component {
  render() {
    this.order = this.props.order;
    this.driver = this.order.driver;

    let address = this.order.delivery_address_detail;
    this.address = address.address;
    this.addressDetail = `${address.city}, ${address.state} ${address.zip}`;

    this.contactNumber = formatContactNumber(this.props.contactNumber);
    this.contactNumberHref = `tel:${this.contactNumber}`;

    return (
      <div className="order-tracking banner-padding">
        <div className="order-header order-tracking-container">
          <h2 className="order-header-title">Order Tracking</h2>
        </div>

        {this.props.children}

        <div
          className={
            'order-info order-tracking-container' +
            (!this.driver ? ' no-driver' : '')
          }
        >
          {this.driver ? (
            <Fragment>
              {this.driver.avatar_url ? (
                <span
                  className="order-info-icon"
                  style={{ backgroundImage: `url(${this.driver.avatar_url})` }}
                />
              ) : (
                <span className="order-info-icon icon-user" />
              )}
              <div className="order-info-driver">
                <span className="order-info-driver-name">
                  {this.driver.first_name}
                </span>
                <div className="order-info-driver-rating">
                  <span
                    className={
                      'order-info-driver-rating-star icon-rating' +
                      (this.driver.currentRating > 0 ? ' active' : '')
                    }
                  />
                  <span
                    className={
                      'order-info-driver-rating-star icon-rating' +
                      (this.driver.currentRating > 1 ? ' active' : '')
                    }
                  />
                  <span
                    className={
                      'order-info-driver-rating-star icon-rating' +
                      (this.driver.currentRating > 2 ? ' active' : '')
                    }
                  />
                  <span
                    className={
                      'order-info-driver-rating-star icon-rating' +
                      (this.driver.currentRating > 3 ? ' active' : '')
                    }
                  />
                  <span
                    className={
                      'order-info-driver-rating-star icon-rating' +
                      (this.driver.currentRating > 4 ? ' active' : '')
                    }
                  />
                </div>
              </div>
            </Fragment>
          ) : (
            <span className="order-info-icon icon-location" />
          )}

          <div className="order-info-address">
            <span className="order-info-address-street text-bold">
              {this.address}
            </span>
            <span className="order-info-address-detail">
              {this.addressDetail}
            </span>
          </div>
          {!!this.contactNumber && (
            <span className="order-info-contact text-bold">
              <a href={this.contactNumberHref}>
                <i className="fa fa-phone" aria-hidden="true" />
                <span className="order-info-contact-number">
                  {this.contactNumber}
                </span>
              </a>
            </span>
          )}
        </div>

        <div className="order-products order-tracking-container">
          <h2 className="order-products-title">Order Summary</h2>
          <div className="order-products-list">
            {this.props.products.map(item => (
              <div className="order-products-list-item" key={item.sku_id}>
                <span
                  className="order-products-list-item-image"
                  style={{ backgroundImage: `url(${item.image})` }}
                />
                <div className="order-products-list-item-info">
                  <span className="order-products-list-item-info-title text-bold">
                    {item.title}
                  </span>
                  <span className="order-products-list-item-info-subtitle">
                    {item.subtitle}
                  </span>
                  <span className="order-products-list-item-info-volume">
                    {item.volume}
                  </span>
                </div>
                <span className="order-products-list-item-qty text-bold">
                  {this.order.skus[item.sku_id]}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { ...state.orderTracking };
}

export default connect(mapStateToProps, { ...actions })(OrderTracking);



// WEBPACK FOOTER //
// ./shared/components/orderTracking/index.js